export default __webpack_public_path__ + "static/media/09.23f2771e.jpg";